import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {tap} from 'rxjs/operators';
import {DynamicModalLoaderService} from './dynamic-modal-loader.service';
import {ConfirmModalLoaderPayload} from '../classes/confirm-modal-loader-payload';
import {ConfirmModalComponent} from '../components/modals/confirm-modal/confirm-modal.component';
import {modalResponse} from '../constants/modal-responses.enum';
import {TunnelResult} from '../classes/tunnel-result';
//TODO: check how migrate
@Injectable()
export class RoutingChangeHandlerService {
  private static MODAL_TITLE = 'Unsaved changes';
  private static MODAL_BODY = 'There are unsaved changes, are you sure you want to exit';
  private static ROUTE_EVENT = 'GuardsCheckStart';

  private _changeHandler: Observable<any>;
  private _counter: number = 0;
  private _subscriptions: Map<number, Subscription> = new Map<number, Subscription>();
  private _handleRequired: Map<number, boolean> = new Map<number, boolean>();
  private _unregisterQueue: Set<number> = new Set<number>();

  constructor(private popupHandler: DynamicModalLoaderService) {
    this.setChangeHandler();
  }

  private setChangeHandler() {
    // this._changeHandler = this.routerHandler.getRoutingListenerFor(RoutingChangeHandlerService.ROUTE_EVENT as any).pipe(
    //     map((routeChangeEvent: { routeEvent: any, resolve: any, reject: any }) => {
    //       let changed = false;
    //       Array.from(this._handleRequired.keys())
    //         .forEach(subscriptionId => {
    //           changed = this.removeSubscription(subscriptionId) || changed;
    //         });
    //       return { routeChangeEvent, changed};
    //     }),
    //     tap((result: any) => {
    //       if (!result.changed) {
    //         result.routeChangeEvent.resolve();
    //       }
    //     }),
    //     filter((result: any) => result.changed),
    //     flatMap((result: any) => this.handleUnsaved(result.routeChangeEvent.resolve, result.routeChangeEvent.reject)),
    //     share()
    //   );
  }

  public handleUnsaved(approveCallback, rejectCallback?): Observable<any> {
    return this.popupHandler.popupModal(ConfirmModalComponent, new ConfirmModalLoaderPayload(
      RoutingChangeHandlerService.MODAL_TITLE,
      RoutingChangeHandlerService.MODAL_BODY,
      'Yes',
      'No'))
      .pipe(
        tap((value: TunnelResult) => {
          if (value.payload === modalResponse.approve) {
            approveCallback();
          }
          else {
            rejectCallback();
          }
        })
      );
  }

  /**
   * Register handler
   * @returns {number}
   */
  public register(withHandler: boolean = true): number {
    const counter = ++this._counter;
    if (withHandler) {
      this._subscriptions.set(counter, this._changeHandler.subscribe());
    }
    else {
      this._subscriptions.set(counter, null);
    }
    return counter;

  }

  /**
   * Unregister handler
   * @param {number} subscriptionId
   * @returns {boolean}
   */
  public unregister(subscriptionId: number): boolean {
    return this.removeSubscription(subscriptionId);
  }


  /**
   * unregister subscription by ID
   * @param subscriptionId
   * @return {boolean} update required
   */
  private removeSubscription(subscriptionId): boolean {
    let updateRequired = false;
    if (this._subscriptions.has(subscriptionId) &&  this._subscriptions.get(subscriptionId)) {
      this._subscriptions.get(subscriptionId).unsubscribe();
      updateRequired = this._handleRequired.get(subscriptionId);
    }
    this._subscriptions.delete(subscriptionId);
    this._handleRequired.delete(subscriptionId);
    this._unregisterQueue.delete(subscriptionId);
    return updateRequired;
  }

  /**
   * Unregister all handlers and return if update required for one of them
   * @returns {boolean}
   */
  public unregisterAll(): boolean {
    let updateRequired = false;
    Array.from(this._subscriptions.keys()).forEach(subscriptionId => {
      updateRequired = updateRequired || this._handleRequired.get(subscriptionId);
      updateRequired = this.removeSubscription(subscriptionId) || updateRequired;
    });
    return updateRequired;
  }

  public setHandlerRequirement(subscriptionId: number, handleRequire: boolean) {
    this._handleRequired.set(subscriptionId, handleRequire);
  }


}
